// extracted by mini-css-extract-plugin
export default {"grid":"benefit-section_grid__3cBg8"};